import Axios, { AxiosRequestConfig } from 'axios';

import { BACKEND_URL } from '../config';

export const AXIOS_INSTANCE = Axios.create({ baseURL: BACKEND_URL });

export const customInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
    return AXIOS_INSTANCE(config).then(({ data }) => data);
};

// variable to store language for api calls
let language = 'en';
export const setLanguage = (lang: string) => {
    language = lang;
    AXIOS_INSTANCE.defaults.headers.common['Accept-Language'] = lang;
};

// on init set the language to the default
setLanguage(language);

export default customInstance;
